import React, { createContext, useState, useEffect } from 'react';
import { onAuthEvent, AUTH_EVENTS } from '../utils/userPreferencesCookie';

export const LocalTimeContext = createContext();

export const LocalTimeProvider = ({ children }) => {
  const [hasLocalTimePreference, setHasLocalTimePreference] = useState(() => {
    // Distinguer :
    // - préférence explicitement choisie (clé présente)
    // - mode auto (clé absente)
    return localStorage.getItem('showLocalTime') !== null;
  });

  const [showLocalTime, setShowLocalTime] = useState(() => {
    // Récupérer l'état depuis le localStorage au chargement
    const savedState = localStorage.getItem('showLocalTime');
    return savedState !== null ? JSON.parse(savedState) : false;
  });

  // Sauvegarder l'état dans le localStorage uniquement si l'utilisateur a explicitement choisi
  // (sinon, on reste en mode auto : absence de clé)
  useEffect(() => {
    if (!hasLocalTimePreference) {
      try {
        localStorage.removeItem('showLocalTime');
      } catch {
        // noop
      }
      return;
    }

    localStorage.setItem('showLocalTime', JSON.stringify(showLocalTime));
  }, [showLocalTime, hasLocalTimePreference]);

  // Écouter les événements d'authentification pour réinitialiser/restaurer l'état
  useEffect(() => {
    const handleSignedOut = () => {
      setShowLocalTime(false);
      setHasLocalTimePreference(false);
      try {
        localStorage.removeItem('showLocalTime');
      } catch {
        // noop
      }
    };
    const handleSignedIn = () => {
      const saved = localStorage.getItem('showLocalTime');
      if (saved !== null) {
        setShowLocalTime(JSON.parse(saved));
        setHasLocalTimePreference(true);
      } else {
        setHasLocalTimePreference(false);
      }
    };
    const cleanupOut = onAuthEvent(AUTH_EVENTS.SIGNED_OUT, handleSignedOut);
    const cleanupIn = onAuthEvent(AUTH_EVENTS.SIGNED_IN, handleSignedIn);
    return () => { cleanupOut(); cleanupIn(); };
  }, []);

  const toggleLocalTime = () => {
    setHasLocalTimePreference(true);
    setShowLocalTime(prevState => !prevState);
  };

  return (
    <LocalTimeContext.Provider value={{ showLocalTime, toggleLocalTime, hasLocalTimePreference }}>
      {children}
    </LocalTimeContext.Provider>
  );
};
